import type { Direction, Locale, Theme } from '../types';
import { directionFor } from '../i18n';

/** Applies locale, direction, theme and the active sector accent to <html>. */
export function applyDocumentChrome(locale: Locale, theme: Theme, accent: string): void {
  const root = document.documentElement;
  const dir: Direction = directionFor(locale);
  root.setAttribute('lang', locale);
  root.setAttribute('dir', dir);
  root.setAttribute('data-theme', theme);
  root.style.setProperty('--brand', accent);
}
